import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducer from 'reducers';
import { devToolsEnhancer } from 'redux-devtools-extension';


// save current game
const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, reducer)

function configureStore() {
    const store = createStore(persistedReducer, devToolsEnhancer({}))
    const persistor = persistStore(store)
    return { persistor, store }
}

export default configureStore
